// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"93da7fa8","992":"c775593d"}[chunkId] + ".chunk.css";
};